"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentBucketUrl = void 0;
// This file won't be exported,
// just put all the shared constants
// that only needs to be shared within this package
exports.contentBucketUrl = 'https://content.cdn.feather-insurance.com';
